import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.css';

import reportWebVitals from './reportWebVitals';
import { trackEvent } from './lib/analytics';
//import i18n from './i18in';
//import 'jquery/dist/jquery.min.js';

//import 'bootstrap/dist/js/bootstrap.min.js';
import Gitfolio from './gitfolio';

// Listen for native beforeprint/afterprint to give charts a chance to resize/update safely
if (typeof window !== 'undefined') {
  const refreshCharts = () => {
    try {
      const winAny = window as any;
      const Chart = winAny?.Chart;
      if (!Chart) return;
      if (typeof Chart.getChart === 'function') {
        document.querySelectorAll('canvas').forEach((c) => {
          const chart = Chart.getChart(c as HTMLCanvasElement);
          if (chart) {
            if (typeof chart.resize === 'function') chart.resize();
            if (typeof chart.update === 'function') chart.update();
          }
        });
      } else if (Chart.instances) {
        Object.values(Chart.instances).forEach((chart: any) => {
          if (chart) {
            if (typeof chart.resize === 'function') chart.resize();
            if (typeof chart.update === 'function') chart.update();
          }
        });
      }
    } catch {
      // ignore
    }
  };
  window.addEventListener('beforeprint', () => {
    refreshCharts();
    window.dispatchEvent(new Event('resize'));
  });
  window.addEventListener('afterprint', () => {
    refreshCharts();
    window.dispatchEvent(new Event('resize'));
  });
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Gitfolio />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Optionally send Web Vitals to GA4
reportWebVitals((metric) => {
  const { name, value, id } = metric as any;
  const params: Record<string, any> = {
    value: Math.round(name === 'CLS' ? value * 1000 : value),
    metric_id: id,
    metric_value: value,
    metric_delta: (metric as any).delta,
  };
  trackEvent(name, params);
});
